import { formatCustomDate } from 'src/app/shared/util/date-utils';

export const POSTULANT_STATUS_MESSAGES = {
  enviado: {
    title: 'Enviado',
    getDescription: (date?: string | null) => {
      if (!date) {
        return 'Tu postulación fue enviada, pero no tenemos la fecha registrada. Nuestro equipo la ha recibido igualmente.';
      }
      return `Tu postulación fue enviada el ${formatCustomDate(
        date
      )}. El área de selección revisará tu perfil pronto.`;
    },
  },
  revisado: {
    title: 'Revisado',
    getDescription: (revised?: string | null) => {
      if (revised === '1') {
        return 'Tu perfil ya fue revisado por nuestro equipo de reclutamiento. Se ha evaluado tu experiencia, habilidades y compatibilidad con el puesto.';
      }
      return 'Aún no hemos revisado tu perfil. El equipo de selección lo hará en breve para considerar tu candidatura.';
    },
  },
  preseleccionado: {
    title: 'Preseleccionado',
    getDescription: (preselected?: string | null) => {
      if (preselected === '1') {
        return '¡Excelente! Has sido preseleccionado para la siguiente etapa del proceso. Nuestro equipo se pondrá en contacto contigo pronto.';
      }
      return 'Aún no has sido preseleccionado. Si cumples con los criterios, te notificaremos en breve.';
    },
  },
  seleccionado: {
    title: 'Seleccionado',
    getDescription: (selected?: string | null) => {
      if (selected === '1') {
        return '¡Felicidades! Has sido seleccionado para continuar en el proceso de reclutamiento. Pronto recibirás más información por correo electrónico.';
      }
      return 'Todavía no has sido seleccionado. Si avanzas en el proceso, te notificaremos oportunamente a través de este portal y por correo.';
    },
  },
};
